"use strict";
/// <reference path="irep.js"/>

IREP.unsubscribe = (function () {
    var options;

    var init = function (unsubscribeOptions) {
        options = unsubscribeOptions;

        $("#Submitbutton").click(function () {
            var regexEmail = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;
            var email = $("#EmailInput");

            $("#confirmation").show();
            $("#confirmText").text("");

            if (email.val() == "") {
                $("#confirmText").text("* " + options.msgEmailError);
                return false;
            };

            if (email.val().match(regexEmail) == null) {
                $("#confirmText").text("* " + options.msgEmailError);
                return false;
            };
            $("#confirmation").hide();

            return true;
        });
    };

    var showConfirmation = function() {
        $("#confirmation").show();
    };

    return {
        init: init,
        showConfirmation: showConfirmation
    };
})();